import ErrMessage from './err-message';

export default ErrMessage;
